<template>
  <b-modal
    id="modal-box-layout"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    title="Layout"
    ok-title="OK"
    cancel-variant="outline-secondary"
    size="lg"
    @ok="handleOk"
    @shown="initBoxes"
  >
    <draggable
      v-model="boxArray"
      class="cursor-move"
      tag="div"
    >
      <b-card
        v-for="box in boxArray"
        :key="'box'+box.id"
        tag="div"

        :class="'col-sm-'+box.boxWidth+' mycard'"
      >{{ box.boxTitle }}
        <br><small>{{ box.projectName }}</small>
        <br><small><strong>Box Id: {{ box.id }}</strong></small>
      </b-card>
    </draggable>

  </b-modal>
</template>

<script>
import {
  BModal, VBModal, BCard,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'

export default {
  components: {
    BModal,
    draggable,
    BCard,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    boxes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      boxArray: [],
    }
  },
  methods: {
    initBoxes() {
      this.boxArray = JSON.parse(JSON.stringify(this.boxes))
    },
    handleOk() {
      // Trigger submit handler
      this.$emit('submit', this.boxArray.map(x => x.id))
    },
  },
}
</script>

<style>
.mycard{ display: inline-block;
}
</style>
